const quickLinks = [
  { label: "O Escritório", href: "#escritorio" },
  { label: "Áreas de Atuação", href: "#areas" },
  { label: "Como Atuamos", href: "#como-atuamos" },
  { label: "Contato", href: "#contato" },
];

const areasLinks = [
  "Direito Previdenciário",
  "Direito Trabalhista",
  "Direito Bancário",
  "Direito de Família",
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#3D0608] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Top golden divider */}
        <div className="flex items-center gap-4 mb-12">
          <div className="h-px flex-1 bg-[#E3B24A]/20" />
          <div className="w-2 h-2 rounded-full bg-[#E3B24A]/50" />
          <div className="h-px flex-1 bg-[#E3B24A]/20" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          {/* Col 1: Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/ecce661685ad1d395f8a319d08998900.png"
              alt="Lupepsa & Marconatto Advocacia"
              className="h-16 w-auto object-contain mb-5"
            />
            <p className="font-body text-[#F2D27A]/55 text-sm leading-relaxed mb-5">
              Advocacia estratégica com excelência e sofisticação. Comprometidos com ética, resultados e atendimento humanizado.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://wa.me/5547999300330"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#E3B24A]/15 border border-[#E3B24A]/25 text-[#E3B24A] hover:bg-[#E3B24A]/30 transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
              <a
                href="https://instagram.com/lupepsaemarconattoadv"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#E3B24A]/15 border border-[#E3B24A]/25 text-[#E3B24A] hover:bg-[#E3B24A]/30 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href="mailto:lupepsaemarconatto.adv@gmail.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#E3B24A]/15 border border-[#E3B24A]/25 text-[#E3B24A] hover:bg-[#E3B24A]/30 transition-colors cursor-pointer"
                aria-label="E-mail"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div>
            <h4 className="font-body font-semibold text-[#E3B24A] text-sm tracking-wider uppercase mb-5">
              <a href="#" id="links-rapidos">Links Rápidos</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleNavClick(link.href)}
                    className="font-body text-[#F2D27A]/55 text-sm hover:text-[#E3B24A] transition-colors cursor-pointer text-left flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#E3B24A]/40 text-xs" />
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Areas */}
          <div>
            <h4 className="font-body font-semibold text-[#E3B24A] text-sm tracking-wider uppercase mb-5">
              <a href="#areas" id="areas-footer">Áreas de Atuação</a>
            </h4>
            <ul className="space-y-3">
              {areasLinks.map((area) => (
                <li key={area}>
                  <button
                    onClick={() => handleNavClick("#areas")}
                    className="font-body text-[#F2D27A]/55 text-sm hover:text-[#E3B24A] transition-colors cursor-pointer text-left flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#E3B24A]/40 text-xs" />
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div>
            <h4 className="font-body font-semibold text-[#E3B24A] text-sm tracking-wider uppercase mb-5">
              <a href="#contato" id="contato-footer">Contato</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-[#E3B24A]/60 text-sm mt-0.5" />
                <span className="font-body text-[#F2D27A]/55 text-sm leading-relaxed">
                  Rua Amazonas, 2850 – Sala 14<br />
                  Garcia – Blumenau/SC
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#E3B24A]/60 text-sm" />
                <a
                  href="https://wa.me/5547999300330"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-[#F2D27A]/55 text-sm hover:text-[#E3B24A] transition-colors cursor-pointer"
                >
                  (47) 9 9930-0330
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-[#E3B24A]/60 text-sm" />
                <a
                  href="mailto:lupepsaemarconatto.adv@gmail.com"
                  className="font-body text-[#F2D27A]/55 text-sm hover:text-[#E3B24A] transition-colors cursor-pointer break-all"
                >
                  lupepsaemarconatto<br />.adv@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-[#E3B24A]/60 text-sm" />
                <a
                  href="https://instagram.com/lupepsaemarconattoadv"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-[#F2D27A]/55 text-sm hover:text-[#E3B24A] transition-colors cursor-pointer"
                >
                  @lupepsaemarconattoadv
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#E3B24A]/10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="text-center sm:text-left">
              <p className="font-body text-[#F2D27A]/40 text-xs">
                <strong className="text-[#F2D27A]/60">Lupepsa &amp; Marconatto Advocacia e Consultoria</strong>
              </p>
              <p className="font-body text-[#F2D27A]/30 text-xs mt-1">
                OAB/SC 45.932 Tania Maria Marconatto – OAB/SC 47.836 Márcia Lupepsa Silveira
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 text-center">
              <p className="font-body text-[#F2D27A]/30 text-xs">
                  Desenvolvido por{" "}
                  <a
                    href="https://startdigital1.com.br"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#E3B24A]/60 hover:text-[#E3B24A] transition-colors cursor-pointer"
                  >
                    Start Digital
                  </a>
                </p>
              <span className="hidden sm:inline text-[#E3B24A]/20">|</span>
              <a href="#" className="font-body text-[#F2D27A]/30 text-xs hover:text-[#E3B24A]/60 transition-colors cursor-pointer">
                Política de Privacidade
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
